import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, InputTypeToken, SizeTypeTokens, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { checkLimitMFCViewDetails, checkPendingCustomerViewDetails, getCompletedRegisteredCustomerDetails, getPendingCustomerDetails, getPendingRegisteredCustomerDetails, onChangeTab, onFilterLeadsAction, onLoadLeadsAction, onLoadMoreData, onRegisterLeads, onSearchLead, onShareLink, onShareLinkWithRef, onSharePendingCustomerLink, onSortLeads, onTrackCustomerJourney, onTrackPendingCustomerJourney, viewDetails, } from "./actions";
import { SideBarBuilderDS } from "../sideNavBar";
import sharedPropsService from "../../SharedPropsService";
import SharedPropsService from "../../SharedPropsService";
import { partnerApi, StoreKey } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { CreditApplicationState, PARTNER_CACHE_EXPIRE_TIME } from "../../configs/constants";
import { navigateByUrl, ShowNewRmContactButton, TableDataBuilder } from "../partnerWeb_Dashboard/utils";
import { addMinutesToCurrentTimeStamp, appendURlWithParam, isMobile, setAppHeader, showMFDLedJourney, showNewPendingCustomer, showPhoneNumber } from "../../configs/utils";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress, openMenu } from "../partnerWeb_Dashboard/actions";
import { BottomNavBuilderDS } from "../bottomNav";
import { LeadsMobStack } from "./indexMob";
import { LeadsMobEmptyStateStack } from "./indexMobEmptyState";
import _ from "lodash";
const _isMobile = isMobile();
export const template = async (partnerListData, partnerAccountType, user, no_of_pending_registration, no_of_completed_registration, showNewRmContactButton, rmData, height, showNewPendingApplicationDashboard, pendingCustomerCount, PendingCustomerData, pendingDataFetched, activeIndex, searchContext, isFromMobile) => ({
    layout: {
        id: ROUTE.PARTNER_LEAD,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            isFromMobile ? {} : { id: 'sideNav', type: WIDGET.STACK, position: POSITION.NAVBAR_LEFT },
            isFromMobile ? { id: 'leadsMobRootStack', type: WIDGET.STACK } : { id: 'leadPageRootStack', type: WIDGET.STACK },
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {},
            showNewPendingApplicationDashboard === true && isFromMobile ? { id: 'pendingApplicationScreen', type: WIDGET.PENDING_MOBILE_APPLICATION_SCREEN } : {},
        ],
    },
    datastore: {
        ...(await PartnerHeader(ROUTE.PARTNER_LEAD, undefined, user)),
        ...await SideBarBuilderDS(ROUTE.PARTNER_LEAD),
        ...await BottomNavBuilderDS(ROUTE.PARTNER_LEAD),
        ...showNewPendingApplicationDashboard === false && await LeadsMobStack(partnerListData?.customerMetadataList, partnerAccountType, user, no_of_pending_registration, no_of_completed_registration),
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.PARTNER_LEAD,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        pendingApplicationScreen: {
            height: height - 94,
            PendingCustomerData,
            pendingCustomerCount,
            pendingDataFetched,
            activeIndex,
            currentSearchContext: searchContext || '',
            pendingCustomerAction: {
                type: ACTION.PENDING_CUSTOMER,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {},
            },
            pendingRegisteredCustomerAction: {
                type: ACTION.PENDING_REGISTRATION,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {},
            },
            registeredCustomerAction: {
                type: ACTION.COMPLETE_REGISTRATION,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {},
            },
            trackPendingCustomerJourney: {
                routeId: ROUTE.PARTNER_LEAD,
                type: ACTION.ON_TRACK_PENDING_CUSTOMER_JOURNEY,
                payload: {},
            },
            pendingCustomerActionNrml: {
                type: ACTION.PENDING_CUSTOMER_NRML,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {},
            },
            pendingRegisteredCustomerActionNrml: {
                type: ACTION.PENDING_REGISTRATION_NRML,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {},
            },
            registeredCustomerActionNrml: {
                type: ACTION.COMPLETE_REGISTRATION_NRML,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {},
            },
            shareLinkAction: {
                routeId: ROUTE.PARTNER_LEAD,
                type: ACTION.SHARE_PENDING_CUSTOMER_LINK,
                payload: {},
            },
            viewDetailsAction: {
                routeId: ROUTE.PARTNER_LEAD,
                type: ACTION.VIEW_PENDING_CUSTOMER_DETAILS,
                payload: {},
            },
            shareLinkRef: {
                routeId: ROUTE.PARTNER_LEAD,
                type: ACTION.SHARE_LINK_REF,
                payload: {},
            },
            clearSearchText: {
                routeId: ROUTE.PARTNER_LEAD,
                type: ACTION.CLEAR_SEARCH_TEXT,
                payload: {},
            }
        },
        leadPageRootStack: {
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            type: StackType.column,
            flex: 1,
            padding: {
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: showNewPendingApplicationDashboard ? [{ id: 'pendingApplicationScreen', type: WIDGET.PENDING_APPLICATION_SCREEN }] :
                partnerListData?.customerMetadataList?.length > 0
                    ? [
                        { id: 'topStack1', type: WIDGET.STACK },
                        { id: 'leadspace0', type: WIDGET.SPACE },
                        { id: 'leadMobDivider', type: WIDGET.DIVIDER },
                        { id: 'leadspace0', type: WIDGET.SPACE },
                        { id: 'filterStack', type: WIDGET.SCROLL_STACK },
                        { id: 'leadspace0', type: WIDGET.SPACE },
                        { id: 'topStack', type: WIDGET.STACK },
                        { id: 'leadspace1', type: WIDGET.SPACE },
                        { id: 'leadTableStack', type: WIDGET.STACK },
                        { id: 'space32', type: WIDGET.SPACE },
                    ]
                    : [
                        { id: 'topStack1', type: WIDGET.STACK },
                        { id: 'leadMobEmptyStateStack', type: WIDGET.STACK }
                    ],
        },
        leadMobDivider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk,
        },
        filterStack: {
            width: '100%',
            widgetItems: [
                { id: 'all_Filter', type: WIDGET.FILTER_CHIP },
                { id: 'filterStackSpace0', type: WIDGET.SPACE },
                { id: 'RegistrationPending_Filter', type: WIDGET.FILTER_CHIP },
                { id: 'filterStackSpace0', type: WIDGET.SPACE },
                { id: 'RegistrationCompleted_Filter', type: WIDGET.FILTER_CHIP }
            ]
        },
        all_Filter: {
            title: 'All',
            noOfItems: `${partnerListData?.customerMetadataList?.length}`,
            selected: true,
            action: {
                type: ACTION.ON_CLICK_FILTER,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    currentStepName: 'All'
                }
            }
        },
        RegistrationPending_Filter: {
            title: 'Registration pending',
            noOfItems: `${no_of_pending_registration}`,
            selected: false,
            action: {
                type: ACTION.ON_CLICK_FILTER,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    filterType: 'Pending registration'
                }
            }
        },
        RegistrationCompleted_Filter: {
            title: 'Registration completed',
            noOfItems: `${no_of_completed_registration}`,
            selected: false,
            action: {
                type: ACTION.ON_CLICK_FILTER,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    filterType: 'Registration complete'
                }
            }
        },
        leadTableStack: {
            type: StackType.row,
            // maxWidth: 800,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'leadTable', type: WIDGET.TABLE },
            ],
        },
        topStack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'leadCountStack', type: WIDGET.STACK },
                partnerListData?.customerMetadataList?.length > 0 ?
                    { id: 'topStackRight1', type: WIDGET.STACK } : {},
            ],
        },
        leadCountStack: {
            type: StackType.column,
            widgetItems: [
                { id: 'leadCountText', type: WIDGET.TEXT },
                { id: 'leadCountT2', type: WIDGET.TEXT },
            ],
        },
        leadCountT2: {
            label: 'Create & track loan applications in progress',
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 20
        },
        topStackRight1: {
            type: StackType.row,
            widgetItems: [
                showMFDLedJourney(partnerAccountType) ? { id: 'registerLeadsBtn', type: WIDGET.BUTTON } : {}
            ],
        },
        registerLeadsBtn: {
            label: 'Register customer',
            type: ButtonTypeTokens.MediumFilled,
            width: ButtonWidthTypeToken.CONTENT,
            action: {
                type: ACTION.ON_REGISTER_LEADS,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {}
            }
        },
        ...showNewPendingApplicationDashboard === false && await LeadsMobEmptyStateStack(partnerAccountType, user),
        leadCountText: {
            label: `Pending applications`,
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            lineHeight: 26,
        },
        leadTable: {
            numOfCol: partnerListData?.customerMetadataList
                ? partnerListData?.customerMetadataList.length
                : 0,
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            titleMap: {
                ...TableDataBuilder(partnerListData?.customerMetadataList, partnerAccountType, user)
                    .Title_MAP,
            },
            titleConfig: {
                ...TableDataBuilder(partnerListData?.customerMetadataList, partnerAccountType, user)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...TableDataBuilder(partnerListData?.customerMetadataList, partnerAccountType, user).DATA,
            },
            data: partnerListData?.customerMetadataList,
            sortAction: {
                type: ACTION.ON_SORT,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    value: '',
                },
            },
            enablePagination: false,
        },
        ...TableDataBuilder(partnerListData?.customerMetadataList, partnerAccountType, user).DATA_STORE,
        topStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'searchStackLeft', type: WIDGET.STACK },
                { id: 'searchStackRight', type: WIDGET.STACK },
            ],
        },
        searchStackLeft: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            flex: 1,
            widgetItems: [{ id: 'leadSeachInput', type: WIDGET.INPUT }],
        },
        searchStackRight: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            flex: 2,
            widgetItems: [],
        },
        leadSeachInput: {
            title: 'Search applications',
            value: '',
            placeholder: showPhoneNumber(partnerAccountType) ? 'Search by name and phone number' : 'Search by name',
            type: InputTypeToken.DEFAULT,
            action: {
                type: ACTION.ON_SEARCH_LEADS,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    value: '',
                    widgetId: 'leadSeachInput',
                },
            },
        },
        leadFilterStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.Grey_Milk,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
            },
            padding: {
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
                horizontal: SizeTypeTokens.XL,
            },
            widgetItems: [
                {
                    id: 'applicationStatusFilterInput',
                    type: WIDGET.DROPDOWN_INPUT,
                },
            ],
        },
        leadDateFilterStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.Grey_Milk,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
            },
            padding: {
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
                horizontal: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'leadDate1', type: WIDGET.CALENDAR_PICKER },
                { id: 'leadDate2', type: WIDGET.CALENDAR_PICKER },
                { id: 'dateFilterBtn', type: WIDGET.BUTTON },
            ],
        },
        leadspace0: { size: SizeTypeTokens.XXXL },
        leadspace1: { size: SizeTypeTokens.LG },
        leadspace3: { size: SizeTypeTokens.XL },
        space32: {
            size: SizeTypeTokens.Size32
        },
        filterStackSpace0: { size: SizeTypeTokens.LG },
    }
});
export const PartnerLeadsMF = {
    onLoad: async ({ openNewTab, asyncStorage, network, navigate, instrumentTrack, getHeight, ...props }, { setIsUserLoggedIn: boolean, currentPendingCustomerActiveTabIndex, currentPage, searchContext, }) => {
        appendURlWithParam('leads');
        await setAppHeader();
        const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const dashboardActiveId = localStorage.getItem('DASHBOARD_ACTIVE_ID');
        const partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
        await sharedPropsService.setPartnerSideBarActiveId(dashboardActiveId);
        const partnerAccountType = user?.linkedPartnerAccounts[0].partnerAccountType;
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        const showNewPendingApplicationDashboard = await showNewPendingCustomer(user);
        if (!accessToken) {
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            return;
        }
        const isFromMobile = isMobile();
        const currentTimeStamp = Date.now().valueOf();
        const cacheExpireTime = await sharedPropsService.getPartnerCacheExpireTime();
        let partnerLeadsData = {
            customerMetadataList: [],
            nextToken: null
        };
        const partnerLeadsDataSharedPropsService = await sharedPropsService.getPartnerLeadsList();
        if ((currentTimeStamp > cacheExpireTime.LeadsCacheExpireTime ||
            partnerLeadsDataSharedPropsService.customerMetadataList.length === 0) && !showNewPendingApplicationDashboard) {
            const response = await network.get(`${partnerApi.clientList}${partnerAccountId}/customers/all`, {
                headers: await getAppHeader(),
            }, async () => { }, {
                isPartnerPlatform: true
            });
            if (response.status === 200) {
                partnerLeadsData['customerMetadataList'] = response?.data?.customerMetadataList.filter((item, index) => {
                    if (item?.creditApplication?.applicationState !== CreditApplicationState.COMPLETED) {
                        return true;
                    }
                    return false;
                });
                // console.log("Response leads On load: ", partnerLeadsData);
                await sharedPropsService.setPartnerLeadsList(partnerLeadsData);
                await sharedPropsService.setPartnerCacheExpireTime({ ...cacheExpireTime, LeadsCacheExpireTime: addMinutesToCurrentTimeStamp(PARTNER_CACHE_EXPIRE_TIME) });
            }
            else {
                // await clearAllData();
                // await partnerNavigate(ROUTE.PARTNER_SIGNUP);
            }
        }
        else {
            partnerLeadsData = await sharedPropsService.getPartnerLeadsList();
        }
        let pageNumber = currentPage || 1;
        let pendingCustomerCount = {};
        let PendingCustomerData = {};
        let pendingDataFetched = false;
        let activeIndex = currentPendingCustomerActiveTabIndex || 1;
        if (showNewPendingApplicationDashboard === true) {
            let dynamicLink = 'allapplication';
            if (currentPendingCustomerActiveTabIndex === 2) {
                dynamicLink = 'registrationpending';
                activeIndex = 2;
            }
            else if (currentPendingCustomerActiveTabIndex === 3) {
                dynamicLink = 'registrationcompleted';
                activeIndex = 3;
            }
            const customersCount = await network.get(`${partnerApi.getAllPendingApplicationDetails}${partnerAccountId}/pending/count`, {
                headers: await getAppHeader(),
            });
            if (customersCount?.status === 200) {
                pendingCustomerCount = customersCount?.data;
            }
            const response = await network.post(`${partnerApi.getAllPendingApplicationDetails}${partnerAccountId}/${dynamicLink}/${pageNumber}`, {
                searchContext: searchContext || "",
            }, { headers: await getAppHeader() });
            if (response?.status === 200) {
                PendingCustomerData = response?.data,
                    pendingDataFetched = true;
            }
        }
        let no_of_pending_registration = 0;
        let no_of_completed_registration = 0;
        if (partnerLeadsData) {
            no_of_pending_registration = partnerLeadsData?.customerMetadataList.filter((data) => {
                if (data?.currentStepName === 'Pending registration') {
                    return true;
                }
                else {
                    return false;
                }
            }).length;
            no_of_completed_registration = partnerLeadsData?.customerMetadataList.filter((data) => {
                if (data?.currentStepName !== 'Pending registration') {
                    return true;
                }
                else {
                    return false;
                }
            }).length;
        }
        const activeWidgetID = await SharedPropsService.getPartnerSideBarActiveId();
        console.log("activeWidgetID: ", activeWidgetID);
        instrumentTrack("LEADS_PAGE_VIEWED");
        const u_data = JSON.parse(await asyncStorage.get(StoreKey.U_DATA));
        const pan = u_data?.pan;
        const phoneNumber = u_data?.phoneNumber;
        if (u_data) {
            const { skipNavigateToRegisterLeads } = u_data;
            if (skipNavigateToRegisterLeads) {
                //
            }
            else {
                await navigate(ROUTE.REGISTER_LEADS);
            }
        }
        const PLJ_borrowerAccountId = await asyncStorage.get(StoreKey.PLJ_borrowerAccountId);
        if (PLJ_borrowerAccountId && PLJ_borrowerAccountId !== '') {
            await navigate(ROUTE.VOLT_APP);
        }
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        return Promise.resolve(template(partnerLeadsData, partnerAccountType, user, no_of_pending_registration, no_of_completed_registration, showNewRmContactButton, rmData, getHeight(), showNewPendingApplicationDashboard, pendingCustomerCount, PendingCustomerData, pendingDataFetched, activeIndex, searchContext, isFromMobile));
    },
    actions: {
        [ACTION.ON_SEARCH_LEADS]: onSearchLead,
        [ACTION.ON_SORT]: onSortLeads,
        [ACTION.ON_LOAD]: onLoadLeadsAction,
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.ON_LOAD_MORE_DATA]: onLoadMoreData,
        [ACTION.ON_TRACK_CUSTOMER_JOURNEY]: onTrackCustomerJourney,
        [ACTION.ON_REGISTER_LEADS]: onRegisterLeads,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.VIEW_DETAILS]: viewDetails,
        [ACTION.SHARE_LINK]: onShareLink,
        [ACTION.SHARE_LINK_REF]: onShareLinkWithRef,
        [ACTION.ON_CLICK_FILTER]: onFilterLeadsAction,
        [ACTION.CHECK_LIMIT_VIEW_DETAILS]: checkLimitMFCViewDetails,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
        [ACTION.PENDING_REGISTRATION]: _.debounce(getPendingRegisteredCustomerDetails, 250),
        [ACTION.COMPLETE_REGISTRATION]: _.debounce(getCompletedRegisteredCustomerDetails, 250),
        [ACTION.PENDING_CUSTOMER]: _.debounce(getPendingCustomerDetails, 250),
        [ACTION.PENDING_REGISTRATION_NRML]: getPendingRegisteredCustomerDetails,
        [ACTION.COMPLETE_REGISTRATION_NRML]: getCompletedRegisteredCustomerDetails,
        [ACTION.PENDING_CUSTOMER_NRML]: getPendingCustomerDetails,
        [ACTION.ON_TRACK_PENDING_CUSTOMER_JOURNEY]: onTrackPendingCustomerJourney,
        [ACTION.SHARE_PENDING_CUSTOMER_LINK]: onSharePendingCustomerLink,
        [ACTION.VIEW_PENDING_CUSTOMER_DETAILS]: checkPendingCustomerViewDetails,
    },
    action: {
        routeId: ROUTE.PARTNER_LEAD,
        type: ACTION.ON_LOAD,
        payload: {
        // isRegisterLeads: _isRegisterLeads
        }
    },
};
